module.exports = __webpack_public_path__ + "img/565f6f03e5c9f0cb30f6580d4f478599.7b107b24.jpg";